function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "trophy",
  transform: "translate(-6 -6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11611",
  "data-name": "Path 11611",
  d: "M21.437,27.691a9.118,9.118,0,0,0,7.291-8.932V6H10.5V18.759a9.117,9.117,0,0,0,7.29,8.931v3.828H14.146v3.646H25.082V31.519H21.437ZM14.146,9.646H25.082v9.114a5.468,5.468,0,1,1-10.937,0Z",
  transform: "translate(0.968)",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11612",
  "data-name": "Path 11612",
  d: "M27,9h3.646v9.114H27Z",
  transform: "translate(4.519 0.646)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11613",
  "data-name": "Path 11613",
  d: "M9.646,9H6v9.114H9.646Z",
  transform: "translate(0 0.646)",
  fill: "#fff"
}));

var SvgTrophy = function SvgTrophy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.165,
    height: 29.165,
    viewBox: "0 0 29.165 29.165",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrophy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trophy.ceb49f7b.svg";
export { ForwardRef as ReactComponent };